import { render, staticRenderFns } from "./ComplainNotification.vue?vue&type=template&id=2969d7ba&scoped=true"
import script from "./ComplainNotification.vue?vue&type=script&lang=js"
export * from "./ComplainNotification.vue?vue&type=script&lang=js"
import style0 from "./ComplainNotification.vue?vue&type=style&index=0&id=2969d7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2969d7ba",
  null
  
)

export default component.exports